import React from 'react';

import { loaders } from '../utils/loaders';

import Modal from '../components/Modal.jsx';
import AllocationsTable from '../components/AllocationsTable.jsx';
import Loading from '../components/Loading.jsx';
import { useParams } from 'react-router-dom';

const UserGrids = () => {
    const params = useParams();
    const col_labels = {
        branch: 'Branches',
        collection: 'Collections',
        fund: 'Funds',
        holding_code: 'Holding Codes',
        item_type: 'Item Types',
        location: 'Locations'
    };

    const [inProgress, setInProgress] = React.useState(true);
    const [error, setError] = React.useState(false);
    const [grids, setGrids] = React.useState({});
    const [visibleTemplate, setVisibleTemplate] = React.useState(null);
    const [showTemplate, setShowTemplate] = React.useState(false);

    React.useEffect(() => {
        (async () => {
            try {
                let resp = await loaders.user_grids.load(params.netsuite_entity);
                setInProgress(false);
                setGrids(resp);
            } catch (error) {
                setError(error);
            }
        })();
    }, [params.netsuite_entity]);

    const showModal = (e) => {
        e.preventDefault();
        let id = e.currentTarget.getAttribute('href').slice(1);
        setVisibleTemplate(grids.templates.find((tmpl) => tmpl._id === id));
        setShowTemplate(true);
    };

    const closeModal = () => {
        setShowTemplate(false);
    };

    if (inProgress) {
        return <Loading />;
    }
    if (!inProgress && error) {
        return <div>Error</div>;
    }
    return (
        <div>
            <h2>Grid Ordering</h2>
            <hr />

            <div className="spaced-double">
                <h4>Templates</h4>
                <table>
                    <thead>
                        <tr>
                            <th className=" table-header">Name</th>
                            <th className=" table-header">Description</th>
                            <th className="a-center table-header">Grid Rows</th>
                            <th className="a-center table-header">Default Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!grids?.templates?.length && (
                            <tr>
                                <td colSpan={5} className="l-text-center">
                                    No templates found
                                </td>
                            </tr>
                        )}
                        {grids.templates &&
                            grids.templates.map((tmpl) => {
                                let tmplQty = 0;
                                tmpl.rows.forEach((row) => (tmplQty += parseInt(row.qty, 10)));
                                return (
                                    <tr key={`grid_template_${tmpl._id}`}>
                                        <td className=" table-cell">
                                            <a href={`#${tmpl._id}`} onClick={showModal}>
                                                {tmpl.name}
                                            </a>
                                        </td>
                                        <td className=" table-cell">{tmpl.desc}</td>
                                        <td className="a-center table-cell">{tmpl.rows.length}</td>
                                        <td className="a-center table-cell">{tmplQty}</td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>

            {grids.columns &&
                grids.columns.map((col) => {
                    return (
                        <div key={col.name} className="spaced-double">
                            <h4 className="table-title">{col_labels[col.name]}</h4>
                            <div className="table-wrapper" id="table_elements">
                                <table>
                                    <thead>
                                        <tr>
                                            <th className=" table-header">Code</th>
                                            <th className=" table-header">Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!col.values.length && (
                                            <tr>
                                                <td colSpan={3} className="l-text-center">
                                                    No records found for {col_labels[col.name]}
                                                </td>
                                            </tr>
                                        )}
                                        {col.values.map((val, index) => {
                                            return (
                                                <tr key={val.code}>
                                                    <td className=" table-cell">{val.code}</td>
                                                    <td className=" table-cell">{val.desc}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
                })}

            <Modal visible={showTemplate} onClose={closeModal}>
                <h4>View Template</h4>
                {!!visibleTemplate && (
                    <div>
                        <ul className="list-flat">
                            <li>
                                <strong>Name:</strong> {visibleTemplate.name}
                            </li>
                            <li>
                                <strong>Description:</strong> {visibleTemplate.desc}
                            </li>
                        </ul>

                        <AllocationsTable
                            allocations={visibleTemplate.rows}
                            isReadOnly
                            account={{ grid: grids }}
                            templateSelect={false}
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default UserGrids;
